module.exports = __webpack_public_path__ + "img/banner4.024d7548.png";